import { Component } from '@angular/core';
import type { State } from '@core/jss-routing';
import { getIsExperienceEditorActive } from '@core/jss-routing';
import type { JssBlogArticle } from '@innogy/knowledge-base/shared';
import {
  getBlogNodeArticles,
  getBlogNodeNumberOfArticles,
  getBlogNodePageSize,
} from '@innogy/knowledge-base/shared';
import { MediaObserverService } from '@innogy/shared/responsive-tools';
import { isNotNullish } from '@innogy/utils-rxjs';
import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { MasonryContentItemModel } from '../masonry/masonry-content-item.model';

@Component({
  selector: 'wl-overview',
  templateUrl: './overview.component.html',
  styleUrls: [],
})
export class OverviewComponent {
  constructor(
    private readonly mediaObserverService: MediaObserverService,
    private readonly store$: Store<State>
  ) {}

  public deviceChange$ = this.mediaObserverService.deviceInfo$;
  public numberOfArticles$ = this.store$.pipe(getBlogNodeNumberOfArticles);
  public pageSize$ = this.store$.pipe(getBlogNodePageSize);
  public isXpEditor$ = this.store$.select(getIsExperienceEditorActive);

  page = 1;
  isLoading = false;

  public masonryItems$: Observable<MasonryContentItemModel[]> =
    this.store$.pipe(
      getBlogNodeArticles,
      map((navItems) =>
        navItems.filter(isNotNullish).map(
          (item: JssBlogArticle): MasonryContentItemModel => ({
            caption: item.summary,
            imageUrl: item.imageUrl,
            itemUrl: item.url,
            title: item.title,
            category: item.category,
          })
        )
      )
    );
}
